/* eslint-disable */
export default {
  noResultFoundFor: 'の結果は見つかりませんでした',
  search: '検索',
} as const;

// @key: @#@"noResultFoundFor"@#@ @source: @#@"No result found for"@#@
// @key: @#@"search"@#@ @source: @#@"Search"@#@
